module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.isOrderLoaded) ? _c('div', {
    staticClass: "div-confirmation"
  }, [_c('header-component'), _vm._v(" "), _c('div', {
    staticClass: "container-fluid g-py-100"
  }, [(!_vm.isDataLoading) ? _c('div', {
    staticClass: "order-confirmation row"
  }, [(_vm.isOrderValid) ? _c('div', {
    staticClass: "col-lg-8 offset-lg-2"
  }, [_c('div', {
    staticClass: "row"
  }, [(_vm.$route.params.isSummaryOnly == '1' && _vm.Order.orderStatus != 'Error') ? _c('div', {
    staticClass: "col-lg-12 col-md-12 col-sm-12 col-xs-12 center"
  }, [_c('h2', {}, [_vm._v("Congratulations!")]), _vm._v(" "), _c('p', {
    staticClass: "order-confimation-description"
  }, [_vm._v("Your order has been submitted successfully.")]), _vm._v(" "), _c('p', {
    staticClass: "order-confimation-description"
  }, [_vm._v("\n              Please print a copy of this for your records and include a copy along with your frame if you have placed a frame-to-come order.\n            ")])]) : (_vm.Order.orderStatus == 'Error') ? _c('div', {
    staticClass: "col-lg-12 col-md-12 col-sm-12 col-xs-12 center"
  }, [_c('p', {
    staticClass: "order-confimation-label"
  }, [_vm._v("Error!")]), _vm._v(" "), _c('p', {
    staticClass: "order-confimation-description"
  }, [_vm._v("This order has an error.")]), _vm._v(" "), _c('p', {
    staticClass: "order-confimation-description"
  }, [_vm._v("\n              Kindly contact the OneSight EssilorLuxottica Foundation team for more information\n            ")])]) : _vm._e(), _vm._v(" "), (_vm.isCoveredPaymentShown) ? _c('div', {
    staticClass: "col-lg-12 col-md-12 col-sm-12 col-xs-12 center"
  }, [_c('p', {
    staticStyle: {
      "color": "green",
      "font-weight": "bold"
    }
  }, [_vm._v("The voucher provided covers the payment amount for this order")])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "col-lg-12"
  }, [_c('div', {
    staticClass: "row text-center"
  }, [_c('div', {
    staticClass: "col-lg-3 col-md-3 col-sm-12 col-xs-12"
  }, [_c('button', {
    staticClass: "btn g-color-white g-bg-main g-bg-primary--hover g-rounded-10 g-my-10",
    on: {
      "click": function($event) {
        return _vm.GenerateHtml()
      }
    }
  }, [_vm._v("Print Exam Summary")])]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-3 col-md-3 col-sm-12 col-xs-12"
  }, [_c('button', {
    staticClass: "btn g-color-white g-bg-main g-bg-primary--hover g-rounded-10 g-my-10",
    on: {
      "click": function($event) {
        return _vm.NewOrder(_vm.Order.id)
      }
    }
  }, [_vm._v("Convert to Order")])]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-3 col-md-3 col-sm-12 col-xs-12"
  }, [_c('button', {
    staticClass: "btn g-color-white g-bg-main g-bg-primary--hover g-rounded-10 g-my-10",
    on: {
      "click": function($event) {
        return _vm.EditOrder(_vm.Order.id)
      }
    }
  }, [_vm._v("Edit")])]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-3 col-md-3 col-sm-12 col-xs-12"
  }, [_c('button', {
    staticClass: "btn g-color-white g-bg-main g-bg-primary--hover g-rounded-10 g-my-10",
    on: {
      "click": function($event) {
        return _vm.ShowDeleteModal(_vm.Order.id)
      }
    }
  }, [_vm._v("Delete")])])])]), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "col-lg-6 col-md-6 col-sm-12 col-xs-12"
  }, [_c('div', {
    staticClass: "form-group no-margin-bottom"
  }, [_c('label', {
    staticClass: "order-confimation-label"
  }, [_vm._v("Patient:")]), _vm._v(" "), _c('span', {
    staticClass: "order-confimation-description"
  }, [_vm._v(_vm._s(_vm.Order.patFirstName) + " " + _vm._s(_vm.Order.patLastName))])])]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-6 col-md-6 col-sm-12 col-xs-12"
  }, [_c('div', {
    staticClass: "form-group no-margin-bottom"
  }, [_c('label', {
    staticClass: "order-confimation-label"
  }, [_vm._v("Participant Name:")]), _vm._v(" "), (_vm.Account.accountType == 1) ? _c('span', {
    staticClass: "order-confimation-description"
  }, [_vm._v(_vm._s(_vm.Account.primaryContact.firstName) + " " + _vm._s(_vm.Account.primaryContact.lastName) + " " + _vm._s(_vm.Account.primaryContact.suffix))]) : _vm._e(), _vm._v(" "), _c('span', {
    staticClass: "order-confimation-description"
  }, [_vm._v(_vm._s(_vm.Account.primaryContact.legalName))])])]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-6 col-md-6 col-sm-12 col-xs-12"
  }, [_c('div', {
    staticClass: "form-group no-margin-bottom"
  }, [_c('label', {
    staticClass: "order-confimation-label"
  }, [_vm._v("Entry ID:")]), _vm._v(" "), _c('span', {
    staticClass: "order-confimation-description"
  }, [_vm._v(_vm._s(_vm.Order.id))])])]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-6 col-md-6 col-sm-12 col-xs-12"
  }, [_c('div', {
    staticClass: "form-group no-margin-bottom"
  }, [_c('label', {
    staticClass: "order-confimation-label"
  }, [_vm._v("Examining Doctor:")]), _vm._v(" "), (_vm.doctor) ? _c('span', {
    staticClass: "order-confimation-description"
  }, [_vm._v(_vm._s(_vm.doctor.lastName) + ", " + _vm._s(_vm.doctor.firstName))]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-6 col-md-6 col-sm-12 col-xs-12"
  }, [_c('div', {
    staticClass: "form-group no-margin-bottom"
  }, [_c('label', {
    staticClass: "order-confimation-label"
  }, [_vm._v("Submitted:")]), _vm._v(" "), _c('span', {
    staticClass: "order-confimation-description"
  }, [_vm._v(_vm._s(_vm.FormatDateToLocal(_vm.Order.dateSubmitted)))])])]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-6 col-md-6 col-sm-12 col-xs-12"
  }, [_c('div', {
    staticClass: "form-group no-margin-bottom"
  }, [_c('label', {
    staticClass: "order-confimation-label"
  }, [_vm._v("Phone:")]), _vm._v(" "), _c('span', {
    staticClass: "order-confimation-description"
  }, [_vm._v(_vm._s(_vm._f("phone_format")(_vm.Account.primaryContact.phoneNumber)))])])]), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "col-lg-6 col-md-6 col-sm-12 col-xs-12"
  }, [_c('div', {
    staticClass: "form-group no-margin-bottom"
  }, [_c('label', {
    staticClass: "order-confimation-label"
  }, [_vm._v("Email:")]), _vm._v(" "), _c('span', {
    staticClass: "order-confimation-description"
  }, [_vm._v(_vm._s(_vm.Account.emailAddress))])])]), _vm._v(" "), _vm._m(2), _vm._v(" "), _c('div', {
    staticClass: "col-lg-12 col-md-12 col-sm-12 col-xs-12 div-spacing-top"
  }, [_c('div', {
    staticClass: "row no-gutters"
  }, [_c('div', {
    staticClass: "col-lg-12 col-md-12 col-sm-12 col-xs-12 border-box min-height-dispenser-notes"
  }, [_c('span', [_vm._v(_vm._s(_vm.Order.dispenserNotes))])])])])])]) : _vm._e(), _vm._v(" "), (!_vm.isOrderValid) ? _c('div', {
    staticClass: "col-lg-8 offset-lg-2"
  }, [_vm._m(3)]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.isDataLoading) ? _c('div', {
    staticClass: "row margin-top"
  }, [_c('page-loader')], 1) : _vm._e()]), _vm._v(" "), (_vm.isServicePaymentShown) ? _c('service-payment', {
    attrs: {
      "Account": _vm.Account,
      "Order": _vm.Order
    },
    on: {
      "close": function($event) {
        _vm.isServicePaymentShown = false
      }
    }
  }) : _vm._e(), _vm._v(" "), _c('footer-component'), _vm._v(" "), (_vm.isDeleteModelShown) ? _c('prompt-component', {
    attrs: {
      "message": _vm.promptMessage
    },
    on: {
      "close": function($event) {
        return _vm.CloseDeleteModal()
      },
      "onAgree": function($event) {
        return _vm.DeleteOrder()
      }
    }
  }) : _vm._e()], 1) : _vm._e()
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-lg-12 col-md-12 col-sm-12 col-xs-12 div-spacing-top"
  }, [_c('div', {
    staticClass: "order-title"
  }, [_vm._v("\n              Participant and Order Information\n            ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-lg-6 col-md-6 col-sm-12 col-xs-12"
  }, [_c('div', {
    staticClass: "form-group no-margin-bottom"
  }, [_c('label', {
    staticClass: "order-confimation-label"
  }, [_vm._v(" ")]), _vm._v(" "), _c('span', {
    staticClass: "order-confimation-description"
  }, [_vm._v(" ")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-lg-12 col-md-12 col-sm-12 col-xs-12 div-spacing-top"
  }, [_c('div', {
    staticClass: "order-title"
  }, [_vm._v("\n              Patient/Order Notes\n            ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-12 col-md-12 col-sm-12 col-xs-12 center"
  }, [_c('p', {
    staticClass: "error-message"
  }, [_vm._v("Error!")]), _vm._v(" "), _c('p', {
    staticClass: "order-confimation-description"
  }, [_vm._v("\n              Order requested is not valid.\n            ")])])])
}]}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-c110f172", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-c110f172"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/portal/Order/ExamConfirmation.vue
// module id = 544
// module chunks = 3